module.exports = __webpack_public_path__ + "img/mine.1661dc58.jpg";